import { render, staticRenderFns } from "./PageCitizens.vue?vue&type=template&id=6c4c8a70&scoped=true&"
import script from "./PageCitizens.vue?vue&type=script&lang=js&"
export * from "./PageCitizens.vue?vue&type=script&lang=js&"
import style0 from "./PageCitizens.vue?vue&type=style&index=0&id=6c4c8a70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c8a70",
  null
  
)

export default component.exports